// German translations (Deutsch)
import type { TranslationKeys } from './en';

export const de: TranslationKeys = {
  // Common
  common: {
    home: 'الرئيسية',
    settings: 'الإعدادات',
    language: 'اللغة',
    loading: 'جاري التحميل...',
    save: 'حفظ',
    cancel: 'إلغاء',
    confirm: 'تأكيد',
    close: 'إغلاق',
    back: 'Back',
    continue: 'Continue',
    accept: 'Accept',
    decline: 'Decline',
    contactEmail: 'contact@zodiac-chess.com',
    companyName: 'Animal Chess Limited',
    companyCountry: 'New Zealand',
  },

  // Settings Menu
  settings: {
    header: 'الإعدادات',
    home: 'الرئيسية',
    howToPlay: 'كيفية اللعب',
    pieceRules: 'قواعد القطع',
    language: 'اللغة',
    manageSubscription: 'إدارة الاشتراك',
    gameHistory: 'تاريخ اللعبة',
    analytics: 'التحليلات',
    premiumAccount: 'حساب مميز',
    chatEnabled: 'الدردشة: مفعلة',
    chatDisabled: 'الدردشة: معطلة',
  },

  // Piece Rules
  pieceRules: {
    title: 'قواعد القطع',
    description: 'تعلم حركة القطع',
    selectPiece: 'اختر القطعة',
    selectedLabel: 'المحدد:',
    statusLabel: 'الحالة:',
    statusReady: 'جاهز',
    statusViewing: 'المشاهدة',
    movement: 'الحركة',
    regularMovement: 'الحركة العادية',
    ability: 'القدرة',
    backToSelection: 'Back to selection',
    backToHome: 'Back to home',
  },

  // Move/Ability Names
  moves: {
    movement: 'الحركة',
    savage: 'متوحش',
    birdtype: 'نوع الطائر',
    birdType: 'نوع الطائر',
    wallBlock: 'حاجز الحائط',
    moveblocks: 'حواجز الحركة',
    wallclimb: 'تسلق الحائط',
    lilypad: 'ورقة اللوتس',
    poisonous: 'سام',
    meadow: 'المرج',
    parasiticfungi: 'فطر طفيلي',
    zombification: 'التحول لزومبي',
    fungi: 'فطر',
    traverse: 'عبور',
    capture: 'أسر',
    faint: 'إغماء',
    leap: 'قفز',
    swing: 'تأرجح',
    consume: 'استهلاك',
    gamble: 'مقامرة',
    entangle: 'تشابك',
    ink: 'حبر',
    rotate: 'دوران',
    backstep: 'خطوة للخلف',
    trample: 'دوس',
    charge: 'هجوم',
    lane: 'مسار',
    snakestrike: 'ضربة الثعبان',
    shedskin: 'تبديل الجلد',
    house: 'منزل',
    plant: 'نوع النبات',
    planttype: 'نوع النبات',
    capturehost: 'أسر المضيف',
    contagion: 'عدوى',
    lonewolf: 'الذئب الوحيد',
    hop: 'قفزة',
    decay: 'تحلل',
    slide: 'انزلاق',
    block: 'حظر',
    poison: 'سم',
    infection: 'عدوى',
    howl: 'عواء',
  },

  // Animation Scenario Descriptions
  scenarios: {
    // Bear
    bearMovement: 'يمكن للدب التحرك مربعاً واحداً في أي اتجاه، مثل الملك في الشطرنج',
    bearMovementPost: 'يتم حظره فقط بواسطة القطع الصديقة (باستثناء الأشجار، الدببة يمكنها تسلق الأشجار!)',
    bearSavage: 'يمكن للدب التغلب على القدرات الدفاعية مثل حظر وحيد القرن',
    bearSavagePost: 'باستخدام المتوحش، يمكن للدب أسر أي قطعة من أي اتجاه، مما يضيف الفتك',

    // Crane
    craneMovement: 'يمكن للكركي التحرك 1 أو 2 مربع في أي خط مستقيم',
    craneMovementPost: 'يمكن للكركي حتى الطيران فوق القطع الأخرى!',
    craneBirdType: 'قطع نوع الطائر لا يمكنها أسر القطع الكبيرة أو المفترسة',
    craneBirdTypePost: 'وهذا يشمل الأشجار ووحيد القرن والدب والذئب',

    // Frog
    frogMovement: 'يقفز الضفدع مربعين قطرياً',
    frogMovementPost: 'لا يمكنه القفز مربعاً واحداً فقط',
    frogWallBlock: 'إذا تم حظر مسار الضفدع العادي المكون من مربعين بواسطة حائط أو قطعة أخرى، فلا يمكنه الأسر',
    frogWallBlockPost: 'تقصر الحركة العادية إلى مربع واحد قطرياً',
    frogWallClimb: 'عندما يكون الضفدع على حائط اللوحة (العمود A أو E) يمكنه التحرك مربعاً واحداً لأعلى أو لأسفل',
    frogWallClimbPost: 'ما لم يكن محظوراً بواسطة قطع صديقة أو وحيد قرن أمام الضفدع',
    frogLilypad: 'إذا لم يتحرك الضفدع بعد في اللعبة، فيمكنه الذهاب إلى أي مكان ضمن أول 3 صفوف، قدرة دفاعية قوية',
    frogLilypadPost: 'يمكن استخدام قفزة ورقة اللوتس لأسر القطع العادية، باستثناء وحيد القرن الذي يكون في رتبة أعلى منه',
    frogPoisonous: 'إذا أسر حيوان قطعة الضفدع، فإنهم يصبحون مسمومين!',
    frogPoisonousPost: 'تتخطى القطعة المسمومة دورها الممكن التالي قبل التعافي',

    // Fungi
    fungiMovement: 'يمكن للفطر التحرك مربعاً واحداً في أي اتجاه',
    fungiMovementPost: 'محظور فقط بواسطة القطع الصديقة',
    fungiMeadow: 'يقلل الفطر من قدرة حركة قطع الأشجار المعادية',
    fungiMeadowPost: 'لا يمكن لقطع الأشجار المعادية التحرك ضمن مربع واحد من قطعة الفطر',
    fungiParasitic: 'يمكن للفطر تثبيت قطع الأشجار المعادية',
    fungiParasiticPost: 'عندما يكون الفطر ضمن مربع واحد من شجرة معادية، لا يمكنها التحرك حتى يبتعد الفطر أو يتم أسره',
    fungiZombification: 'يمكن للفطر تحويل قطعة الحيوان المعادي الذي يأسره إلى زومبي، للتحكم في الحيوان المعادي لدور واحد',
    fungiZombificationPost: 'تعتبر القطعة المحولة أيضاً قطعة فطر لذلك الدور، وإذا كان الفطر ملكاً فلن تنتهي اللعبة حتى نهاية ذلك الدور',
    fungiFungi: 'Pilz',
    fungiFungiPost: 'مثل السم والتشابك وعدوى الفيروس، على الرغم من أن التحويل لزومبي استثناء لأن الزومبي يمكنه تحويل الآخرين!',

    // Goat
    goatMovement: 'يمكن للماعز التحرك مربعاً واحداً في أي اتجاه',
    goatMovementPost: 'الماعز بطيء الحركة ولكن لديه قدرات قوية',
    goatTraverse: 'يمكن للماعز عبور القطع الأخرى المتصلة مما يخلق إمكانات حركة هائلة',
    goatTraversePost: 'لا يمكن للماعز عبور القطع الصغيرة مثل الماعز المغمى عليه أو الفيروس',
    goatCapture: 'لا يمكن للماعز أسر المفترسات',
    goatCapturePost: 'مثل الدب أو الذئب',
    goatFaint: 'يمكن للماعز الإغماء لتجنب الأسر باستثناء القطع الكبيرة مثل الأشجار ووحيد القرن',
    goatFaintPost: 'أثناء الإغماء، يمكن للخصم "الوقوف" فوق الماعز المغمى عليه لحظر الحركة',

    // Monkey
    monkeyMovement: 'يمكن للقرد التحرك مربعاً واحداً في أي اتجاه',
    monkeyMovementPost: 'بدون قطع أخرى للاستفادة منها، القرد محدود الحركة',
    monkeyLeap: 'يمكن للقرد القفز فوق القطع الأخرى في خط مستقيم مثل لعبة الداما مما يمنح إمكانات حركة هائلة',
    monkeyLeapPost: 'لكن القفز فوق قطع العدو يجعل القرد يدحرج النرد للبقاء على قيد الحياة، مع فرصة 1/6 للأسر لكل عدو يقفز فوقه!',
    monkeySwing: 'عندما يقفز القرد فوق شجرة يحصل على دور إضافي',
    monkeySwingPost: 'استخدام التأرجح على الشجرة يخلق كومبو تآزري قوي بين القرد وقطع الشجرة',
    monkeyConsume: 'يمكن للقرد استهلاك قطعة الفطر والحصول على دور إضافي',
    monkeyConsumePost: 'عند دمجه مع الأدوار الإضافية الأخرى يؤدي إلى كومبو مدمر',
    monkeyGamble: 'بالإضافة إلى دحرجة النرد للقفز فوق الأعداء، يجب على القرد المقامرة لأسر الدب',
    monkeyGamblePost: 'يجب على القرد دحرجة 5 أو 6 على نرد من 6 جوانب لأسر الدب، وإلا سيتم أسره',

    // Octopus
    octopusMovement: 'يتحرك الأخطبوط مربعاً واحداً في أي اتجاه',
    octopusCapture: 'يمكن للأخطبوط الأسر فقط بزوايا قائمة',
    octopusCapturePost: 'يمكن للأخطبوط أسر أو تشابك القطع بطرق معقدة، لذا تحقق دائماً من الأسر الأحمر والتشابك البنفسجي!',
    octopusEntangle: 'يمكن للأخطبوط تشابك قطع العدو القريبة التي تثبتها، ويمكنه تشابك الأعداء بالتحرك مربعاً واحداً!',
    octopusEntanglePost: 'لا يمكن للقطعة المتشابكة التحرك حتى يبتعد الأخطبوط أو يتم أسره',
    octopusInk: 'يمكن للأخطبوط استخدام الحبر للهروب من المواقف الخطرة وإنشاء ما يصل إلى 3 ظلال',
    octopusInkPost: 'إرباك الأعداء وتمكين ألعاب الطعم والمراوغة المثيرة',

    // Penguin
    penguinMovement: 'ينزلق البطريق في خط مستقيم في الاتجاه المحدد ويستمر حتى يوقف حائط أو قطعة الحركة',
    penguinMovementPost: 'بعد الحركة، يمكن للبطريق أيضاً تعيين اتجاهه النهائي ضمن نفس الدور',
    penguinRotate: 'في بداية المباراة، يكون البطريق متجهاً للأسفل ويجب أن يدور قبل الانزلاق، يسمى أيضاً بالنوم',
    penguinRotatePost: 'يمكن للبطريق اختيار الدوران بدلاً من الحركة من أي موضع',
    penguinBirdType: 'البطريق لديه قدرات أسر محدودة مثل الكركي، ولا يمكنه أسر القطع الكبيرة أو المفترسة مثل الأشجار ووحيد القرن والدب والذئب',
    penguinBirdTypePost: 'بعد الأسر، يمكن للبطريق الدوران في أي اتجاه للوضع الاستراتيجي',

    // Rhino
    rhinoMovement: 'يتحرك وحيد القرن مربعين للأمام فقط',
    rhinoMovementPost: 'لا يمكنه التحرك مربعاً واحداً فقط',
    rhinoBackStep: 'يمكن لوحيد القرن التحرك للخلف الأيسر أو الخلف الأيمن',
    rhinoCharge: 'يمكن لوحيد القرن استخدام قدرة الهجوم مرة واحدة في اللعبة مما يسمح له بالتحرك مربعاً إضافياً للأمام',
    rhinoChargePost: 'يؤدي إلى حركة مدمرة وإمكانات أسر',
    rhinoTrample: 'يأسر وحيد القرن جميع القطع في طريقه عن طريق الدوس',
    rhinoTramplePost: 'بما في ذلك قطع الماعز المغمى عليها',
    rhinoLane: 'يمكن لوحيد القرن تبديل الأماكن مع قطع صديقة أخرى للعب المسار الاستراتيجي',
    rhinoLanePost: 'ولكن فقط إذا لم يتحرك كل من وحيد القرن والقطعة الصديقة',

    // Snake
    snakeMovement: 'يمكن للثعبان التحرك مربعين في خط مستقيم',
    snakeMovementPost: 'يتحرك الثعبان بالضبط مربعين ما لم يكن محظوراً بواسطة حائط أو قطع صديقة',
    snakeMoveBlocks: 'إذا تم حظره بواسطة حائط أو قطعة غير قابلة للأسر، تقصر حركة الثعبان إلى مربع واحد',
    snakeMoveBlocksPost: 'لا يزال بإمكانه التحرك مربعين حتى مع قطع في المنتصف',
    snakeStrike: 'إذا كان هناك حيوان عدو، يمكن للثعبان الضرب حتى 3 مربعات للأمام',
    snakeStrikePost: 'ما لم تكن هناك قطع متوسطة تحظر الطريق',
    snakeShedskin: 'مرة واحدة في اللعبة، يمكن للثعبان تبديل الجلد والعودة إلى الصف الأول إذا كان المربع فارغاً',
    snakeShedskinPost: 'هذه الولادة الجديدة تمنح الثعبان حياة إضافية في كل لعبة',

    // Tree
    treeMovement: 'يمكن للشجرة التحرك مربعاً واحداً للأمام أو إلى أي مربع يساراً أو يميناً في نفس الصف',
    treeMovementPost: 'ما لم يكن الطريق محظوراً',
    treeHouse: 'يمكن للشجرة إيواء قطع أخرى لحمايتها من الأعداء الذين لا يمكنهم تسلق الشجرة. القطع التي يمكنها التسلق: الدب، الكركي، الضفدع، الفطر، الماعز، القرد، الأخطبوط، الثعبان',
    treeHousePost: 'إذا هاجمت قطعة يمكنها تسلق الشجرة، فإنها تأسر فقط القطعة المأواة، لحماية الشجرة',
    treeTrample: 'تأسر الشجرة جميع القطع في المربع عند التحرك إليه مثل وحيد القرن',
    treeTramplePost: 'بما في ذلك الماعز المغمى عليه',
    treePlant: 'الشجرة ليست حيواناً بل نبات، لذا فهي محصنة ضد العديد من التأثيرات',
    treePlantPost: 'مثل السم والتحويل لزومبي والتشابك وعدوى الفيروس!',

    // Virus
    virusMovement: 'يمكن للفيروس التحرك فقط إلى المربعات التي يشغلها حيوان على بعد مربعين',
    virusMoveBlocks: 'يمكن للفيروس التحرك مربعاً واحداً فقط عندما يكون بجوار حائط',
    virusCaptureHost: 'عندما يهبط الفيروس (يدخل) على قطعة حيوان، فإنه يصيب فقط، ويمكنه مواصلة اللعب العادي أثناء الإصابة',
    virusCaptureHostPost: 'يأسر الفيروس القطعة فقط عند مغادرة المضيف المصاب',
    virusContagion: 'يمكن للفيروس إصابة عدة مضيفين في دور واحد مما ينتشر بسرعة',
    virusContagionPost: 'من خلال العدوى، يمكن للفيروس القيام بأكبر عدد ممكن من الحركات القانونية في كل دور كما يريد',

    // Wolf
    wolfMovement: 'يمكن للذئب التحرك في شكل L مثل الفارس في الشطرنج',
    wolfMovementPost: 'غير معاق بواسطة القطع الأخرى',
    wolfLoneWolf: 'Wolf',
    wolfLoneWolfPost: 'يعتبر الذئب وحيداً إذا كان لديه فقط ماعز مغمى عليه أو أصدقاء فيروس',
  },

  // Tutorials
  tutorials: {
    dragToExploreMobile: '👆 اسحب للاستكشاف • اقرص للتكبير',
    dragToExploreDesktop: '🖱️ اسحب للاستكشاف • مرر للتكبير',
    previousConstellation: 'Previous constellation',
    nextConstellation: 'Next constellation',
    lockedNextHint: 'Complete at least 3 {constellation} tutorials to move to the next constellation',
    lockedStateLabel: 'Star Path',
    freeStateLabel: 'Free Roam',
    clickToFreeRoam: 'Click to free roam',
    clickForStarPath: 'Click for Star Path',
    // Tutorial popups
    failed: 'FAILED!',
    success: 'SUCCESS!',
    failedDefaultMessage: "Don't give up! Try a different approach.",
    superMessage: 'Perfect! You achieved Super completion!',
    passMessage: 'Well done! Tutorial completed!',
    tryAgain: 'Try Again',
    back: 'Zurück',
    next: 'Weiter',
    backToDev: 'Back to Dev',
    backToTutorials: 'Back to Tutorials',
    continue: 'Continue',
    close: 'Close',
  },

  // Sandbox
  sandbox: {
    title: 'صندوق الرمل',
    description: 'التجربة والممارسة',
    mode: 'الوضع:',
    modeValue: 'صندوق الرمل',
    status: 'الحالة:',
    statusReady: 'جاهز',
    clearBoard: 'مسح اللوحة',
  },

  // Multiplayer
  multiplayer: {
    title: 'متعدد اللاعبين',
    description: 'ابحث عن خصوم وتنافس!',
    // Rematch
    rematchRequest: 'Rematch Request',
    rematchMessage: '{opponent} wants to play again!',

    // Placement matches
    placementMatches: 'مباريات التصنيف',
    matchProgress: 'تقدم المباراة',
    gamesCompleted: '{games} / 10 ألعاب مكتملة',
    estimatedFinalRating: 'التصنيف النهائي المقدر',
    startingRating: 'التصنيف الابتدائي',
    matchesRemaining: '{matches} مباريات متبقية',
    findPlacementMatch: 'ابحث عن مباراة تصنيف',

    // Matchmaking modes
    findMatch: 'ابحث عن مباراة',
    competitive: 'تنافسي',
    competitiveDesc: 'ابحث عن خصوم برتبة مماثلة',
    quick: 'مباراة سريعة',
    quickDesc: 'ابحث بسرعة عن مباراة تنافسية',
    casual: 'عادي',
    casualDesc: 'Ohne Rang - spiele zum Spaß!',
    placement: 'Platzierung',
    placementDesc: 'Absolviere 10 Spiele für eine Wertung',
    startSearch: 'Suche starten',

    // Searching
    searching: 'البحث جاري...',
    mode: 'الوضع:',
    inQueue: 'في الطابور:',
    players: 'لاعب',
    playersPlural: 'لاعبون',
    cancelSearch: 'إلغاء البحث',

    // Game info
    status: 'الحالة:',
    ready: 'جاهز',
    selectingKing: 'اختيار الملك',
    placingPieces: 'وضع القطع',
    playing: 'اللعب',
    gameType: 'نوع اللعبة:',
    opponent: 'الخصم:',
    opponentElo: 'ELO الخصم:',
    unranked: 'غير مصنف',

    // Piece placement
    dragPieces: 'اسحب القطع إلى اللوحة',
    lightPieces: 'القطع الفاتحة (أنت)',
    darkPieces: 'القطع الداكنة (أنت)',

    // Waiting states
    waitingForOpponent: 'في انتظار الخصم...',
    waitingForKing: 'في انتظار اختيار الخصم للملك...',

    // Warnings
    invalidPlacement: 'موضع غير صالح',
    lightTurn: 'إنه دور اللاعب الفاتح!',
    darkTurn: 'إنه دور اللاعب الداكن!',
    onlyLightPieces: 'يمكنك وضع القطع الفاتحة فقط!',
    onlyDarkPieces: 'يمكنك وضع القطع الداكنة فقط!',
    mustPlaceOnRow: 'يجب وضع قطع {color} في الصف {row}!',

    // Chat
    chat: 'الدردشة',
    typeMessage: 'اكتب رسالة...',
    send: 'إرسال',
  },

  // Main Page
  mainPage: {
    title: 'شطرنج الحيوانات',
    subtitle: 'لعبة للبشر',
    playersOnline: 'اللاعبون على الإنترنت الآن',
    placement: 'التصنيف',
    placementProgress: 'التصنيف',
    challengeAI: 'تحدي الذكاء الاصطناعي',
    multiplayer: 'متعدد اللاعبين',
    sandbox: 'صندوق الرمل',
    tutorials: 'دروس تعليمية',
    shop: 'المتجر',
    collection: 'المجموعة',
    history: 'التاريخ',
    analytics: 'التحليلات',
    courses: 'الدورات',
    upgradeAccount: 'ترقية الحساب',
    signIn: 'تسجيل الدخول',
    playAsGuest: 'العب كضيف',
    welcomeBack: 'مرحباً بعودتك! عادة تلعب كـ',

    // Learn the Pieces section
    learnThePieces: 'تعلم القطع',

    // Learn the Rules section
    learnTheRules: 'تعلم القواعد',
    premiseTitle: 'المقدمة',
    premiseText: 'Zodiac هي بديل للشطرنج مع ملك مخفي من قائمة من 13 قطعة، اختر قائمتك الفريدة ثم اخدع خصمك واهزمه على لوحة 5x8',
    selectionTitle: 'الاختيار',
    selectionText: 'لبدء اللعبة، اختر ملكك سراً ثم تناوب مع خصمك لوضع 5 قطع لإنشاء واحد من أكثر من 500 مليار موضع بداية.',
    objectiveTitle: 'الهدف',
    objectiveText: 'اقرأ خصمك لأسر ملكه السري أو احصل على النصر بتحريك ملكك إلى الجانب الآخر من اللوحة!',
    competeTitle: 'تنافس',
    competeText: 'اختبر مهاراتك على السلم، طور تقنيات واستراتيجيات شخصية جديدة، وارتقِ في الرتب للعب ضد الأفضل!',
    fullRulesButton: 'انقر هنا للقواعد الرسمية الكاملة',

    // FAQ section
    faqTitle: 'الأسئلة الشائعة',
    faqQuestion1: 'ما هي فكرة Zodiac شطرنج؟',
    faqAnswer1: 'تم إلهام Zodiac شطرنج من كلمات Bobby Fischer حول الإلهام لإنشاء Chess960. أردنا توسيع فكرة محاربة الحفظ الميكانيكي والاحتفال بالحدس البشري في عمق لا يحصى!',
    faqQuestion2: 'لماذا نحتاج بديلاً للشطرنج',
    faqAnswer2: 'لا نحتاج! Zodiac لا يريد إبعاد الناس عن لعب الشطرنج! إنه خيار آخر له إيجابيات وسلبيات خاصة به، ونأمل أن تستمتع وتساعد في ضبط هذه اللعبة لتمكين اللعب الجديد',
    faqQuestion3: 'كيف تفوز في Zodiac شطرنج؟',
    faqAnswer3: 'يمكنك الفوز بثلاث طرق: أسر قطعة الملك المخفي للخصم، أو تحريك ملكك إلى الجانب الآخر من اللوحة، أو نفاد وقت خصمك في المباريات الموقوتة',
    faqQuestion4: 'هل هذا سؤال شائع؟',
    faqAnswer4: 'نعم، يمكنك رؤية جميع الأسئلة المدرجة في الأسئلة الشائعة وإذا أردت مزيداً من التفاصيل، انقر على السؤال ثم اقرأ التفاصيل مثل هذه التي تقرأها الآن',
    faqQuestion5: 'كم من الوقت تستغرق اللعبة النموذجية؟',
    faqAnswer5: 'كل لعبة مختلفة جداً! يمكن أن تنتهي بعض الألعاب في دورين ويمكن أن يستغرق البعض 30 دقيقة، عادة 5-15 دقيقة!',
    faqQuestion6: 'ماذا يحدث إذا لم يتمكن أحد من القيام بحركة قانونية؟',
    faqAnswer6: 'إذا لم يتمكن اللاعب من القيام بحركة قانونية (جمود)، تنتهي اللعبة بالتعادل. يمكن أن تنتهي اللعبة أيضاً بالتعادل من خلال التكرار (نفس حالة اللوحة 3 مرات) أو بالاتفاق المتبادل بين اللاعبين!',

    // About section
    aboutButton: 'حول',
    privacyPolicy: 'سياسة الخصوصية',
    developerInterface: 'واجهة المطور',
  },

  // About Modal
  about: {
    title: 'حول Zodiac',
    paragraph1: 'Zodiac هي لعبة لوحة تشبه الشطرنج تجمع بين عناصر اختيار القطع من ألعاب مثل LoL و DotA مع آليات الخداع من البوكر أو ألعاب الاستنتاج الاجتماعي.',
    paragraph2: 'تم إنشاء النسخة الأولى من اللعبة في عام 2014 باسم Shadow Chess. في عام 2018 تم إعادة تصميمها لتشمل قائمة ممتعة من القطع بأنماط حركة وقدرات متوازنة ولكن فريدة وهو ما تراه اليوم.',
    paragraph3: 'رؤيتنا هي تسجيل جميع بيانات اللعب للمستخدمين للاستمرار في تطوير اللعبة للحفاظ على اللعب منعشاً وتشجيع اللعب الجديد.',
    paragraph4: 'مع مساحة البحث الضخمة لـ Zodiac والمعلومات المخفية ومواضع اللوحة الافتتاحية، نأمل في إيقاف هيمنة الذكاء الاصطناعي والحفاظ على Zodiac كلعبة للبشر!',
  },

  // Privacy Policy
  privacy: {
    title: 'سياسة الخصوصية',
    lastUpdated: 'آخر تحديث',

    introduction: {
      title: 'مقدمة',
      p1: 'مرحباً بك في Zodiac Chess ("نحن" أو "لنا" أو "خاصتنا"). نحن ملتزمون بحماية خصوصيتك وتوفير تجربة لعب آمنة وممتعة. توضح سياسة الخصوصية هذه كيفية جمع معلوماتك واستخدامها والكشف عنها وحمايتها عند استخدام موقعنا الإلكتروني ولعبتنا.',
      p2: 'باستخدام Zodiac Chess، فإنك توافق على جمع واستخدام المعلومات وفقاً لهذه السياسة. إذا كنت لا توافق على سياساتنا وممارساتنا، فلا تستخدم خدماتنا.',
      contact: 'اتصل:',
    },

    infoCollect: {
      title: 'المعلومات التي نجمعها',
      accountInfo: {
        title: '1. معلومات الحساب',
        item1: 'عنوان البريد الإلكتروني: مطلوب لإنشاء الحساب والاتصالات',
        item2: 'اسم المستخدم: اسم العرض الذي اخترته',
        item3: 'كلمة المرور: مشفرة ومخزنة بشكل آمن',
      },
      gameData: {
        title: '2. بيانات اللعبة',
        item1: 'إحصائيات اللعبة: الانتصارات، الخسائر، تصنيف ELO، تقدم مباريات التصنيف',
        item2: 'بيانات اللعب: اختيارات القطع، الحركات، الاستراتيجيات المستخدمة',
        item3: 'سجل المباريات: سجل الألعاب الملعوبة، الخصوم الذين واجهتهم',
        item4: 'المشتريات داخل اللعبة: العناصر التجميلية وحالة العضوية المميزة',
      },
      technicalData: {
        title: '3. البيانات التقنية',
        item1: 'معلومات الجهاز: نوع المتصفح، نظام التشغيل',
        item2: 'بيانات الاستخدام: الصفحات التي تمت زيارتها، الوقت المستغرق، الميزات المستخدمة',
        item3: 'التخزين المحلي: تفضيلات اللغة، إعدادات واجهة المستخدم، حالة اللعبة المؤقتة',
      },
    },

    children: {
      title: 'خصوصية الأطفال (امتثال COPPA)',
      p1: 'تم تصميم Zodiac Chess لتكون مناسبة للعائلة ومناسبة للاعبين من جميع الأعمار بما في ذلك الأطفال. نحن نتخذ احتياطات خاصة للامتثال لقانون حماية خصوصية الأطفال على الإنترنت (COPPA).',
      p2: 'للمستخدمين الذين تقل أعمارهم عن 13 عاماً: نوصي باستخدام وضع اللعب كضيف الذي لا يتطلب إنشاء حساب أو جمع بيانات. لا تتمتع الحسابات الضيف بإمكانية الوصول إلى ميزات الدردشة النصية، مما يضمن عدم تعرض الأطفال للتواصل مع الإنترنت الأوسع. إذا قام طفل بإنشاء حساب، فنحن نطلب موافقة الوالدين قبل جمع أي معلومات شخصية.',
      p3: 'نحن لا نجمع أو نستخدم أو نشارك عن عمد المعلومات الشخصية من الأطفال الذين تقل أعمارهم عن 13 عاماً دون موافقة الوالدين التي تم التحقق منها.',
      p4: 'أمان الدردشة: يتم تعطيل الدردشة النصية تلقائياً لجميع حسابات الضيف/المؤقتة. يمكن لأصحاب الحسابات القياسية تعطيل ميزة الدردشة في أي وقت من إعدادات حساباتهم.',
      parentalRights: 'الآباء لديهم الحق في:',
      right1: 'مراجعة المعلومات الشخصية لأطفالهم',
      right2: 'طلب حذف بيانات أطفالهم',
      right3: 'رفض المزيد من الجمع أو استخدام معلومات أطفالهم',
      contactUs: 'لممارسة هذه الحقوق، أو إذا كنت تعتقد أن طفلك قد قدم لنا معلومات شخصية، يرجى الاتصال بنا على الفور على contact@zodiac-chess.com',
    },

    howWeUse: {
      title: 'كيف نستخدم معلوماتك',
      item1: 'توفير وتحسين خدمات اللعبة',
      item2: 'مطابقة مع الخصوم المناسبين بناءً على مستوى المهارة',
      item3: 'تتبع التقدم والإحصائيات والإنجازات',
      item4: 'معالجة المدفوعات للعضويات المميزة والعناصر التجميلية',
      item5: 'إرسال إشعارات الخدمة المهمة والتحديثات',
      item6: 'تحليل بيانات اللعب لتحسينات توازن اللعبة والميزات',
    },

    thirdParty: {
      title: 'خدمات الطرف الثالث',
      firebase: {
        title: 'Firebase (Google)',
        description: 'نستخدم Firebase للمصادقة وتخزين قاعدة البيانات ووظائف متعدد اللاعبين. قد تجمع Firebase بيانات معينة كما هو موضح في سياسة الخصوصية الخاصة بها.',
      },
      stripe: {
        title: 'Stripe',
        description: 'نستخدم Stripe لمعالجة المدفوعات للعضويات المميزة والمشتريات داخل التطبيق. تتعامل Stripe مع جميع معلومات بطاقة الدفع - نحن لا نرى أو نخزن تفاصيل الدفع الكاملة الخاصة بك.',
      },
      netlify: {
        title: 'Netlify',
        description: 'يتم استضافة موقعنا على Netlify، والذي قد يجمع بيانات استضافة الويب القياسية مثل عناوين IP وسجلات الوصول.',
      },
      adsense: {
        title: 'Google AdSense (مستقبلي)',
        description: 'قد نعرض إعلانات من خلال Google AdSense. قد تستخدم هذه الإعلانات ملفات تعريف الارتباط للتخصيص. بالنسبة للمحتوى الموجه للأطفال، نعرض فقط إعلانات غير مخصصة للامتثال لـ COPPA.',
      },
      viewPolicy: 'عرض سياسة الخصوصية',
    },

    cookies: {
      title: 'ملفات تعريف الارتباط والتخزين المحلي',
      description: 'نستخدم تخزين المتصفح المحلي (مشابه لملفات تعريف الارتباط) لتحسين تجربتك:',
      item1: 'تفضيلات اللغة: تذكر لغتك المختارة',
      item2: 'جلسة الحساب: إبقاءك مسجلاً الدخول (يعمل مع Firebase)',
      item3: 'إعدادات اللعبة: تذكر تفضيلات واجهة المستخدم وإعدادات صندوق الرمل',
      item4: 'ملفات تعريف ارتباط الإعلانات: بموافقتك، قد تستخدم خدمات الإعلانات التابعة لجهات خارجية ملفات تعريف الارتباط لتخصيص الإعلانات',
    },

    security: {
      title: 'أمان البيانات',
      p1: 'ننفذ تدابير أمنية مناسبة لحماية معلوماتك:',
      item1: 'تشفير كلمة المرور: يتم تشفير جميع كلمات المرور باستخدام طرق معيارية في الصناعة',
      item2: 'اتصالات آمنة: تشفير HTTPS لجميع عمليات نقل البيانات',
      item3: 'قواعد أمان Firebase: ضوابط صارمة للوصول إلى قاعدة البيانات',
      p2: 'ومع ذلك، لا توجد طريقة نقل عبر الإنترنت آمنة بنسبة 100٪. بينما نسعى جاهدين لحماية بياناتك، لا يمكننا ضمان الأمان المطلق.',
    },

    retention: {
      title: 'الاحتفاظ بالبيانات',
      p1: 'نحتفظ ببياناتك على النحو التالي:',
      item1: 'الحسابات النشطة: يتم الاحتفاظ بالبيانات طالما كان حسابك نشطاً',
      item2: 'الحسابات غير النشطة: قد نحذف البيانات إذا كان حسابك غير نشط لمدة 10 سنوات',
    },

    rights: {
      title: 'حقوق الخصوصية الخاصة بك',
      description: 'اعتماداً على موقعك، قد يكون لديك الحقوق التالية:',
      access: {
        title: 'الوصول:',
        description: 'طلب نسخة من بياناتك الشخصية',
      },
      correction: {
        title: 'التصحيح:',
        description: 'طلب تصحيح البيانات',
      },
      deletion: {
        title: 'الحذف:',
        description: 'طلب حذف الحساب والبيانات',
      },
      portability: {
        title: 'قابلية نقل البيانات:',
        description: 'طلب البيانات بتنسيق محمول',
      },
      optOut: {
        title: 'إلغاء الاشتراك:',
        description: 'إلغاء الاشتراك في اتصالات التسويق',
      },
      contact: 'لممارسة هذه الحقوق، يرجى الاتصال بنا على contact@zodiac-chess.com',
    },

    international: {
      title: 'المستخدمون الدوليون',
      p1: 'تعمل Zodiac Chess من نيوزيلندا. إذا كنت تصل إلى خدماتنا من خارج نيوزيلندا، يرجى ملاحظة أن معلوماتك قد يتم نقلها وتخزينها ومعالجتها في نيوزيلندا وبلدان أخرى حيث يعمل مزودو خدماتنا.',
      p2: 'باستخدام خدماتنا، فإنك توافق على نقل معلوماتك إلى بلدان خارج بلد إقامتك، والتي قد يكون لها قوانين مختلفة لحماية البيانات.',
    },

    changes: {
      title: 'التغييرات على سياسة الخصوصية هذه',
      description: 'قد نقوم بتحديث سياسة الخصوصية هذه من وقت لآخر. سنخطرك بأي تغييرات عن طريق نشر سياسة الخصوصية الجديدة على هذه الصفحة وتحديث تاريخ "آخر تحديث". سيتم الإبلاغ عن التغييرات المادية عبر البريد الإلكتروني أو إشعار بارز على موقعنا.',
    },

    contact: {
      title: 'اتصل بنا',
      description: 'إذا كان لديك أي أسئلة أو مخاوف أو طلبات بشأن سياسة الخصوصية هذه أو ممارسات البيانات الخاصة بنا، يرجى الاتصال بنا:',
      email: 'البريد الإلكتروني:',
      company: 'الشركة:',
    },

    cookieConsent: {
      title: 'Cookie Consent & Control',
      p1: 'We believe in transparency and giving you control over your data. When you first visit Zodiac Chess, you will be presented with a cookie consent banner that allows you to choose which types of cookies you want to accept.',
      categories: {
        title: 'Cookie Categories',
        necessary: {
          title: 'Necessary Cookies',
          description: ' These cookies are essential for the website to function properly. They enable core features like authentication, game state management, and security. You cannot opt out of these cookies.',
        },
        analytics: {
          title: 'Analytics Cookies',
          description: ' These cookies help us understand how visitors interact with our website by collecting anonymous usage data through Firebase Analytics. This helps us improve the game experience.',
        },
        advertising: {
          title: 'Advertising Cookies',
          description: ' These cookies are used by Google AdSense to display personalized advertisements. Premium members never see ads, regardless of consent settings.',
        },
      },
      control: {
        title: 'How to Control Cookies',
        p1: 'You have several options to manage your cookie preferences:',
        method1: 'Cookie Banner: On your first visit, you can accept all cookies, reject optional cookies, or customize your preferences.',
        method2: 'Browser Settings: Most browsers allow you to refuse or delete cookies through their settings menu.',
        method3: 'Opt-Out Links: For advertising cookies, you can opt out of personalized ads using the links below.',
      },
      optOut: {
        title: 'Opt Out of Personalized Advertising',
        p1: 'If you would like to opt out of personalized advertising from Google and other ad networks, you can use these resources:',
        googleAds: 'Google Ad Settings - Manage Google personalized ads',
        daa: 'Digital Advertising Alliance (DAA) - Opt out of interest-based ads',
        eaa: 'European Interactive Digital Advertising Alliance (EDAA) - EU users opt-out',
      },
      moreInfo: 'For more detailed information about the cookies we use, please visit our',
      cookiePolicyLink: 'Cookie Policy',
    },
  },

  // Cookie Consent Banner
  cookieConsentBanner: {
    title: 'We Value Your Privacy',
    description: 'We use cookies to enhance your experience, analyze site usage, and show personalized ads (for free users only). You can customize your preferences at any time.',
    acceptAll: 'Accept All',
    rejectAll: 'Reject Optional',
    customize: 'Customize',
    savePreferences: 'Save Preferences',
    back: 'Back',
    necessary: 'Necessary Cookies',
    necessaryDesc: 'Required for the site to function. These cannot be disabled.',
    analytics: 'Analytics Cookies',
    analyticsDesc: 'Help us understand how you use the site to improve your experience.',
    advertising: 'Advertising Cookies',
    advertisingDesc: 'Used to show personalized ads (free users only, premium members never see ads).',
    privacyPolicy: 'Privacy Policy',
    cookiePolicy: 'Cookie Policy',
  },

  // Terms of Service
  terms: {
    title: 'Nutzungsbedingungen',
    lastUpdated: 'Zuletzt aktualisiert',
    back: 'Zurück',
    viewPrivacyPolicy: 'Datenschutzrichtlinie ansehen',
    acknowledgment: 'Durch die Nutzung von Zodiac Chess bestätigen Sie, dass Sie diese Nutzungsbedingungen gelesen und verstanden haben und sich an diese gebunden fühlen.',
    acceptance: {
      title: '1. Annahme der Bedingungen',
      p1: 'Durch den Zugriff auf und die Nutzung von Zodiac Chess (der "Dienst") akzeptieren Sie diese Nutzungsbedingungen. Wenn Sie diesen Bedingungen nicht zustimmen, nutzen Sie den Dienst bitte nicht.',
      p2: 'Wir behalten uns das Recht vor, diese Bedingungen jederzeit zu ändern. Die fortgesetzte Nutzung des Dienstes nach Änderungen gilt als Annahme der geänderten Bedingungen.',
    },
    description: {
      title: '2. Beschreibung des Dienstes',
      p1: 'Zodiac Chess ist ein Online-Strategie-Brettspiel mit einzigartigen Tierfiguren mit besonderen Fähigkeiten. Der Dienst umfasst:',
      feature1: 'Einzelspieler-Gameplay gegen KI-Gegner',
      feature2: 'Multiplayer-Matchmaking und Wettbewerbsspiel',
      feature3: 'Interaktive Tutorials und Lernressourcen',
      feature4: 'Kontoerstellung und Fortschrittsverfolgung',
      feature5: 'Optionale Premium-Abonnement-Funktionen',
      feature6: 'Kosmetische Anpassungsoptionen',
    },
    accounts: {
      title: '3. Benutzerkonten',
      eligibility: {
        title: '3.1 Berechtigung',
        p1: 'Sie müssen mindestens 13 Jahre alt sein, um ein Konto zu erstellen. Benutzer unter 13 Jahren können den Gastmodus unter elterlicher Aufsicht nutzen, können aber keine Konten erstellen.',
      },
      responsibilities: {
        title: '3.2 Kontosicherheit',
        p1: 'Sie sind verantwortlich für:',
        item1: 'Die Wahrung der Vertraulichkeit Ihres Passworts',
        item2: 'Alle Aktivitäten, die unter Ihrem Konto stattfinden',
        item3: 'Die sofortige Benachrichtigung über jede unbefugte Nutzung',
        p2: 'Wir haften nicht für Verluste oder Schäden, die aus unbefugtem Kontozugriff entstehen.',
      },
      prohibited: {
        title: '3.3 Verbotene Aktivitäten',
        p1: 'Sie dürfen NICHT:',
        item1: 'Ihr Konto mit anderen teilen',
        item2: 'Mehrere Konten verwenden, um Rankings zu manipulieren',
        item3: 'Bots, Skripte oder automatisierte Tools zum Spielen verwenden',
        item4: 'Andere Spieler belästigen, missbrauchen oder bedrohen',
        item5: 'Bugs oder Fehler für unfaire Vorteile ausnutzen',
        item6: 'Reverse Engineering durchführen oder versuchen, auf unseren Quellcode zuzugreifen',
        p2: 'Ein Verstoß gegen diese Regeln kann zur Kontosperrung oder dauerhaften Sperrung führen.',
      },
    },
    premium: {
      title: '4. Premium-Abonnements',
      billing: {
        title: '4.1 Abrechnung',
        p1: 'Premium-Abonnements werden über Stripe abgewickelt. Mit dem Kauf eines Premium-Abonnements ermächtigen Sie uns, Ihre Zahlungsmethode wiederkehrend zu belasten, bis Sie kündigen.',
        p2: 'Die Abonnementgebühren sind:',
        item1: 'Monatlicher Plan: Monatliche Abbuchung am Jahrestag Ihres Kaufdatums',
        item2: 'Jährlicher Plan: Jährliche Abbuchung am Jahrestag Ihres Kaufdatums',
        p3: 'Preise können sich mit 30 Tagen Vorankündigung an aktive Abonnenten ändern.',
      },
      cancellation: {
        title: '4.2 Kündigung',
        p1: 'Sie können Ihr Abonnement jederzeit über Ihre Kontoeinstellungen oder durch Kontaktaufnahme mit dem Support kündigen. Die Kündigung wird am Ende des aktuellen Abrechnungszeitraums wirksam.',
        p2: 'Sie behalten Premium-Funktionen bis zum Ende Ihres bezahlten Zeitraums, auch nach der Kündigung.',
      },
      refunds: {
        title: '4.3 Rückerstattungen',
        p1: 'Monatliche Abonnements: Keine Rückerstattung für angebrochene Monate. Kündigen Sie jederzeit, um zukünftige Gebühren zu stoppen.',
        p2: 'Jährliche Abonnements: Volle Rückerstattung bei Anfrage innerhalb von 7 Tagen nach dem Kauf. Nach 7 Tagen liegt die Rückerstattung in unserem Ermessen.',
        p3: 'Kosmetische Käufe: Generell nicht erstattungsfähig. Kontaktieren Sie den Support für außergewöhnliche Umstände.',
      },
    },
    acceptable: {
      title: '5. Richtlinie zur akzeptablen Nutzung',
      p1: 'Sie stimmen zu, Zodiac Chess auf respektvolle und rechtmäßige Weise zu nutzen. Verbotenes Verhalten umfasst:',
      item1: 'Schummeln, Hacken oder Ausnutzen von Spielmechaniken',
      item2: 'Belästigung, Hassrede oder diskriminierende Sprache',
      item3: 'Spamming, Werbung oder Anwerbung',
      item4: 'Teilen unangemessener Inhalte (wenn Chat oder nutzergenerierte Inhalte aktiviert sind)',
      item5: 'Sich als andere Benutzer oder Mitarbeiter ausgeben',
      item6: 'Versuchen, den Dienst zu stören oder zu beschädigen',
      p2: 'Wir behalten uns das Recht vor, Verstöße zu untersuchen und geeignete Maßnahmen zu ergreifen, einschließlich Kontokündigung und Meldung an Behörden, falls erforderlich.',
    },
    intellectual: {
      title: '6. Geistige Eigentumsrechte',
      ownership: {
        title: '6.1 Unsere Inhalte',
        p1: 'Alle Spielinhalte, einschließlich, aber nicht beschränkt auf Spielmechaniken, Kunstwerke, Animationen, Soundeffekte, Code und Design, sind Eigentum von Animal Chess Limited oder unseren Lizenzgebern.',
        p2: 'Ihnen wird eine begrenzte, nicht-exklusive, nicht übertragbare Lizenz zur Nutzung des Dienstes nur für persönliche Unterhaltungszwecke gewährt.',
      },
      userContent: {
        title: '6.2 Benutzerinhalte',
        p1: 'Durch das Einreichen von Inhalten (wie Chat-Nachrichten, Benutzernamen oder Profilinformationen) gewähren Sie uns eine weltweite, gebührenfreie Lizenz zur Nutzung, Anzeige und Verbreitung dieser Inhalte in Verbindung mit dem Dienst.',
        p2: 'Sie versichern, dass Sie alle eingereichten Inhalte besitzen oder die erforderlichen Rechte daran haben.',
      },
    },
    disclaimers: {
      title: '7. Haftungsausschlüsse und Haftungsbeschränkungen',
      p1: 'DER DIENST WIRD "WIE BESEHEN" OHNE JEGLICHE GARANTIEN, WEDER AUSDRÜCKLICH NOCH STILLSCHWEIGEND, BEREITGESTELLT.',
      p2: 'Wir garantieren nicht, dass:',
      item1: 'Der Dienst ununterbrochen oder fehlerfrei sein wird',
      item2: 'Mängel behoben werden',
      item3: 'Der Dienst frei von Viren oder schädlichen Komponenten ist',
      item4: 'Die Ergebnisse der Nutzung des Dienstes Ihren Erwartungen entsprechen werden',
      p3: 'IM MAXIMAL GESETZLICH ZULÄSSIGEN UMFANG HAFTEN WIR NICHT FÜR:',
      item5: 'Jegliche indirekten, zufälligen oder Folgeschäden',
      item6: 'Verlust von Gewinnen, Daten oder Geschäftswert',
      item7: 'Dienstunterbrechungen oder Datenverlust',
      item8: 'Schäden, die den Betrag übersteigen, den Sie uns in den letzten 12 Monaten gezahlt haben',
    },
    privacy: {
      title: '8. Datenschutz',
      p1: 'Ihre Nutzung des Dienstes unterliegt auch unserer Datenschutzrichtlinie, die erklärt, wie wir Ihre persönlichen Daten erfassen, verwenden und schützen.',
      p2: 'Durch die Nutzung des Dienstes stimmen Sie unseren Datenpraktiken zu, wie in der Datenschutzrichtlinie beschrieben.',
    },
    changes: {
      title: '9. Änderungen der Bedingungen',
      p1: 'Wir behalten uns das Recht vor, diese Nutzungsbedingungen jederzeit zu ändern. Wir werden Benutzer über wesentliche Änderungen informieren durch:',
      item1: 'E-Mail-Benachrichtigung an registrierte Benutzer',
      item2: 'Auffälligen Hinweis auf der Website',
      item3: 'Aktualisiertes "Zuletzt aktualisiert"-Datum oben auf dieser Seite',
      p2: 'Ihre fortgesetzte Nutzung des Dienstes nach Änderungen gilt als Annahme der geänderten Bedingungen.',
    },
    governing: {
      title: '10. Anwendbares Recht',
      p1: 'Diese Nutzungsbedingungen unterliegen den Gesetzen Neuseelands, ohne Berücksichtigung von Kollisionsnormen.',
      p2: 'Alle Streitigkeiten, die sich aus diesen Bedingungen oder Ihrer Nutzung des Dienstes ergeben, werden vor den Gerichten Neuseelands beigelegt.',
    },
    contact: {
      title: '11. Kontaktinformationen',
      p1: 'Bei Fragen, Bedenken oder Support bezüglich dieser Nutzungsbedingungen:',
      email: 'E-Mail:',
      company: 'Unternehmen:',
      address: 'Adresse:',
    },
    severability: {
      title: '12. Salvatorische Klausel',
      p1: 'Sollte eine Bestimmung dieser Bedingungen als nicht durchsetzbar oder ungültig befunden werden, wird diese Bestimmung auf das notwendige Minimum beschränkt oder gestrichen, und die übrigen Bestimmungen bleiben in vollem Umfang wirksam.',
    },
  },

  // Cookie Policy
  cookiePolicy: {
    title: 'Cookie-Richtlinie',
    lastUpdated: 'Zuletzt aktualisiert',
    // Browser instructions
    browserInstructions: {
      chrome: 'Einstellungen → Datenschutz und Sicherheit → Cookies',
      firefox: 'Einstellungen → Datenschutz & Sicherheit → Cookies und Website-Daten',
      safari: 'Einstellungen → Datenschutz → Cookies und Website-Daten',
      edge: 'Einstellungen → Datenschutz, Suche und Dienste → Cookies',
    },
    // Cookie table headers
    cookieTable: {
      name: 'Cookie-Name',
      purpose: 'Zweck',
      duration: 'Dauer',
      type: 'Typ',
    },
    // Related Policies
    relatedPolicies: {
      title: 'Verwandte Richtlinien',
      description: 'Für weitere Informationen darüber, wie wir Ihre Daten verarbeiten, besuchen Sie bitte:',
      privacy: 'Datenschutzrichtlinie',
      terms: 'Nutzungsbedingungen',
    },
    introduction: {
      title: 'Einführung',
      p1: 'Diese Cookie-Richtlinie erklärt, wie Zodiac Chess ("wir," "unser") Cookies und ähnliche Technologien verwendet, wenn Sie unsere Website besuchen.',
      p2: 'Durch die Nutzung unserer Website stimmen Sie unserer Verwendung von Cookies gemäß dieser Richtlinie zu. Wenn Sie nicht einverstanden sind, deaktivieren Sie bitte Cookies in Ihren Browsereinstellungen oder nutzen Sie unsere Website nicht.',
    },
    what: {
      title: 'Was sind Cookies?',
      p1: 'Cookies sind kleine Textdateien, die auf Ihrem Gerät (Computer, Smartphone, Tablet) platziert werden, wenn Sie eine Website besuchen. Sie werden häufig verwendet, um Websites effizient arbeiten zu lassen und den Website-Betreibern Informationen zu liefern.',
      p2: 'Cookies dienen verschiedenen Zwecken, einschließlich dem Speichern Ihrer Präferenzen, der Analyse der Website-Nutzung und der Aktivierung bestimmter Funktionen.',
    },
    types: {
      title: 'Arten von Cookies, die wir verwenden',
      necessary: {
        title: '1. Notwendige Cookies',
        description: 'Diese Cookies sind für das ordnungsgemäße Funktionieren der Website unerlässlich. Ohne diese Cookies können die von Ihnen angeforderten Dienste nicht bereitgestellt werden.',
        examples: 'Beispiele:',
        item1: 'Authentifizierungs-Cookies - halten Sie in Ihrem Konto angemeldet',
        item2: 'Sicherheits-Cookies - schützen vor betrügerischen Aktivitäten',
        item3: 'Sitzungs-Cookies - erhalten Ihren Spielstand während einer Sitzung',
        item4: 'Cookie-Einwilligungspräferenzen - merken sich Ihre Cookie-Auswahl',
      },
      analytics: {
        title: '2. Analyse-Cookies',
        description: 'Diese Cookies helfen uns zu verstehen, wie Besucher mit unserer Website interagieren, indem sie anonyme Informationen über Seitenbesuche, verbrachte Zeit und genutzte Funktionen sammeln.',
        provider: 'Anbieter: Firebase Analytics (Google)',
        purpose: 'Zweck:',
        item1: 'Messung des Website-Traffics und der Nutzerinteraktion',
        item2: 'Identifizierung beliebter Funktionen und Seiten',
        item3: 'Verständnis der Nutzerdemografie (Altersgruppe, allgemeiner Standort)',
        item4: 'Verbesserung der Website-Leistung und Nutzererfahrung',
      },
      advertising: {
        title: '3. Werbe-Cookies',
        description: 'Diese Cookies werden verwendet, um Ihnen relevante Werbung anzuzeigen. Sie begrenzen auch die Häufigkeit, mit der Sie eine Anzeige sehen, und helfen, die Wirksamkeit von Werbekampagnen zu messen.',
        provider: 'Anbieter: Google AdSense',
        purpose: 'Zweck:',
        item1: 'Anzeige personalisierter Werbung basierend auf Ihren Interessen',
        item2: 'Messung der Anzeigenleistung und -interaktion',
        item3: 'Verhindern, dass dieselbe Anzeige zu oft angezeigt wird',
        note: 'Hinweis: Premium-Abonnenten sehen niemals Werbung, unabhängig von den Cookie-Einstellungen.',
      },
    },
    firstThird: {
      title: 'Erstanbieter- vs. Drittanbieter-Cookies',
      firstParty: {
        title: 'Erstanbieter-Cookies',
        description: 'Dies sind Cookies, die direkt von Zodiac Chess gesetzt werden. Wir verwenden sie für wesentliche Website-Funktionen, Authentifizierung und das Speichern Ihrer Präferenzen.',
      },
      thirdParty: {
        title: 'Drittanbieter-Cookies',
        description: 'Dies sind Cookies, die von externen Diensten gesetzt werden, die wir nutzen, wie Google Analytics und Google AdSense. Drittanbieter-Cookies unterliegen den Datenschutzrichtlinien dieser Anbieter.',
      },
    },
    specific: {
      title: 'Spezifische Cookies, die wir verwenden',
      tableHeader: 'Nachfolgend finden Sie eine detaillierte Liste der auf unserer Website verwendeten Cookies:',
    },
    control: {
      title: 'Wie Sie Cookies kontrollieren können',
      consent: {
        title: '1. Cookie-Einwilligungsbanner',
        description: 'Wenn Sie unsere Website zum ersten Mal besuchen, sehen Sie ein Cookie-Einwilligungsbanner. Sie können:',
        item1: 'Alle akzeptieren - Alle Cookies erlauben (notwendige, Analyse- und Werbe-Cookies)',
        item2: 'Optionale ablehnen - Nur notwendige Cookies erlauben (keine Analyse oder Werbung)',
        item3: 'Anpassen - Genau auswählen, welche Arten von Cookies Sie erlauben möchten',
      },
      browser: {
        title: '2. Browsereinstellungen',
        description: 'Die meisten Webbrowser ermöglichen es Ihnen, Cookies über ihre Einstellungen zu kontrollieren. Sie können:',
        item1: 'Alle Cookies blockieren',
        item2: 'Nur Erstanbieter-Cookies akzeptieren',
        item3: 'Cookies nach jeder Browsersitzung löschen',
        item4: 'Einzelne Cookies anzeigen und löschen',
        links: 'Hier sind Links zur Cookie-Verwaltung für beliebte Browser:',
      },
      optOut: {
        title: '3. Opt-Out-Tools',
        description: 'Speziell für Werbe-Cookies können Sie personalisierte Werbung ablehnen:',
        googleLink: 'Google-Anzeigeneinstellungen',
        googleDesc: ' - Personalisierte Google-Anzeigen verwalten',
        daaLink: 'Digital Advertising Alliance (DAA)',
        daaDesc: ' - Interessenbasierte Werbung ablehnen',
        edaaLink: 'European Interactive Digital Advertising Alliance (EDAA)',
        edaaDesc: ' - EU-spezifisches Opt-Out-Tool',
      },
    },
    impact: {
      title: 'Auswirkungen der Deaktivierung von Cookies',
      p1: 'Wenn Sie Cookies deaktivieren oder ablehnen, beachten Sie bitte, dass:',
      item1: 'Einige Teile der Website möglicherweise nicht richtig funktionieren',
      item2: 'Sie möglicherweise bei jedem Besuch Ihre Präferenzen erneut eingeben müssen',
      item3: 'Sie möglicherweise aus Ihrem Konto abgemeldet werden',
      item4: 'Notwendige Cookies sind für das Funktionieren der Website erforderlich - ihre Deaktivierung verhindert die Nutzung der Kernfunktionen',
    },
    updates: {
      title: 'Aktualisierungen dieser Cookie-Richtlinie',
      p1: 'Wir können diese Cookie-Richtlinie von Zeit zu Zeit aktualisieren, um Änderungen in unseren Praktiken oder aus rechtlichen, regulatorischen oder betrieblichen Gründen widerzuspiegeln.',
      p2: 'Wir werden Sie über wesentliche Änderungen informieren, indem wir das Datum "Zuletzt aktualisiert" oben auf dieser Seite aktualisieren. Bitte überprüfen Sie diese Richtlinie regelmäßig.',
    },
    contact: {
      title: 'Kontaktieren Sie uns',
      p1: 'Wenn Sie Fragen zu unserer Verwendung von Cookies oder dieser Cookie-Richtlinie haben, kontaktieren Sie uns bitte:',
      email: 'E-Mail:',
      company: 'Unternehmen:',
    },
  },

  // Game
  game: {
    yourTurn: 'Du bist dran',
    opponentTurn: 'Gegner ist dran',
    victory: 'Sieg!',
    defeat: 'Niederlage',
    draw: 'Unentschieden',
    resign: 'Aufgeben',
    offerDraw: 'Remis anbieten',
  },

  // Game End Popup
  gameEnd: {
    victory: 'SIEG!',
    defeat: 'NIEDERLAGE!',
    draw: 'UNENTSCHIEDEN!',
    wonBy: 'Gewonnen durch {condition}',
    lostBy: 'Verloren durch {condition}',
    drawBy: 'Unentschieden durch {condition}',
    youCapturedTheirKing: 'You captured their {piece} King!',
    yourKingWasCaptured: 'Your {piece} King was captured!',
    rematchButton: 'Rematch',
    backButton: 'Back',
    conditions: {
      kingslayer: 'Königsmord',
      race: 'Rennsieg',
      timeout: 'Zeitüberschreitung',
      threefold: '3-fache Wiederholung',
      noMoves: 'Keine gültigen Züge',
      draw: 'Unentschieden',
    },
  },

  // Game Info
  gameInfo: {
    title: 'Spielinfo',
    sandboxMode: 'Sandbox-Modus',
    lightTurn: 'Hell ist dran',
    darkTurn: 'Dunkel ist dran',
    yourTurn: 'Du bist dran',
    opponentTurn: 'Gegner ist dran',
    aiThinking: 'KI denkt nach...',

    // Selection states
    selecting: 'Wähle {piece}',
    observing: 'Beobachte {piece}',
    selectingZombified: 'Wähle zombifizierten Feind {piece}',
    selectionLocked: 'Auswahl gesperrt auf {piece}',
    selectionLockedPenguin: 'Pinguin ist auswahlgesperrt',

    // Hints
    clickToFaint: 'Klicke auf {piece} zum Ohnmacht spielen',
    clickToRotate: 'Klicke auf {piece} zum Drehen',
    clickToInk: 'Klicke auf {piece} für Tinte',
    zombifiedWarning: '⚠️ Während zombifiziert dreht sich {piece} vor dem Bewegen!',

    // Monkey bonus turn
    monkeySwing: 'Affe hat Schwung abgeschlossen, bewege deinen Affen um den Bonuszug zu beenden',
    monkeyConsume: 'Affe hat Pilz gefressen, bewege deinen Affen um den Bonuszug zu beenden',

    // Virus bonus turn
    virusInfecting: 'Virus infiziert, setze Zug fort oder klicke auf Virus um Zug zu beenden',

    // Penguin bonus turn
    penguinRotate: 'Pinguin hat Gleiten abgeschlossen - wähle finale Drehrichtung',
    penguinCaptureRotate: 'Pinguin hat Schlagen abgeschlossen - wähle finale Drehrichtung',
    penguinZombified: 'Zombifizierter Pinguin hat gedreht - beende Zug mit Gleiten/Schlagen (Zombifizierung endet)',

    // Capture restrictions
    cannotCapture: '{piece} kann nicht schlagen: {targets}',
    cannotInfect: '{piece} kann nicht infizieren: {targets}',
    cannotEntangle: '{piece} kann nicht verstricken: {targets}',
    monkeyBearRoll: '{piece} muss 5-6 würfeln um feindlichen {target} zu schlagen',
    cannotBeCapturedBy: '{piece} cannot be captured by: {attackers}',
    monkeyNeedsRoll: '{attacker} needs to roll 5-6 to capture',

    // Meadow warning (Tree immobilization)
    meadowWarning: '{piece} is immobilized by enemy {fungi}',
    rhinoChargeWarning: '{piece} charge does not affect: {targets}',
    snakeStrikeWarning: '{piece} strike does not affect: {targets}',
  },

  // Piece names
  pieces: {
    Bear: 'Bär',
    Crane: 'Kranich',
    Frog: 'Frosch',
    Fungi: 'Pilz',
    Goat: 'Ziege',
    Monkey: 'Affe',
    Octopus: 'Krake',
    Penguin: 'Pinguin',
    Rhino: 'Nashorn',
    Snake: 'Schlange',
    Tree: 'Baum',
    Virus: 'Virus',
    Wolf: 'Wolf',
  },

  // Short poetic vibe descriptions for landing carousel — one per variant
  pieceVibes: {
    Bear:    { light: 'Few dare approach',                   dark: 'Nothing impedes her hunger' },
    Crane:   { light: 'Sailing above, quieter than the wind',      dark: 'It circles. It waits. The lonely never return home' },
    Frog:    { light: 'Lazing on the lily pad',       dark: 'Take the colors as a warning' },
    Fungi:   { light: 'The meadow-maker',         dark: 'Consume and see who has been consumed' },
    Goat:    { light: 'Catch me on the cliff side',   dark: 'The corpse that blinks' },
    Monkey:  { light: 'Branch to branch to foe, laughing all the way',               dark: 'Roll the bones. Smiles either way' },
    Octopus: { light: 'Soft arms, razor sharp hooks, never releasing its grip',  dark: 'A bloom of black water. The shape inside is gone' },
    Penguin: { light: 'A harmless little thing in a tiny black coat',        dark: 'Slow and cute, right?' },
    Rhino:   { light: 'Waiting to face down a challenger', dark: 'Lock eyes at your peril' },
    Snake:   { light: 'Changing endings like outfits',                               dark: 'Do not tread near me' },
    Tree:    { light: 'A haven amongst the beasts',             dark: 'Standing where the dead stood. Still standing' },
    Virus:   { light: 'The battle for pandoras box',         dark: 'They feel triumph, then a cough, then silent disbelief' },
    Wolf:    { light: 'The alpha of his pack',  dark: 'When the pack is gone. What remains excites' },
  },


  // Move Context (piece descriptions)
  moveContext: {
    title: 'Zugkontext',
    emptyState: 'Wähle eine Fähigkeit aus dem linken Panel für detaillierte Informationen.',
  },

  // Challenge AI
  challengeAI: {
    // Title and tagline
    title: 'KI-ARENA',
    tagline: 'Wähle eine KI zum Kämpfen oder schau KI-Duellen zu!',

    // Player labels
    lightPlayer: 'Heller Spieler',
    darkPlayer: 'Dunkler Spieler',
    humanPlayer: 'Menschlicher Spieler',
    aiPlayer: 'AI',
    difficulty: 'Difficulty',
    difficultyEasy: 'Easy',
    difficultyMedium: 'Medium',
    difficultyHard: 'Hard',

    // AI Models
    aiGaia: 'Gaia',
    aiSentinel: 'Wächter',
    aiAlchemist: 'Alchemist',
    aiZenith: 'Zenit',
    aiTrapper: 'Fallensteller',
    aiHunter: 'Jäger',
    aiWisp: 'Irrlicht',
    aiCreature: 'Creature',
    aiWeaver: 'Weber',

    // Time Frames
    timeFast: 'Schnell',
    timeStandard: 'Standard',
    timeDeep: 'Tief',

    // Thinking time
    thinkingTime: 'Denkzeit',

    // Info box
    matchupLabel: 'Begegnung:',
    statusLabel: 'Status:',
    statusPaused: 'PAUSIERT',
    statusAIThinking: 'KI denkt nach...',
    statusInGame: 'Im Spiel',
    statusReady: 'Bereit',
    matchupLocal2P: 'Lokal 2P',
    matchupPlayerVs: 'Spieler gegen',
    matchupVsPlayer: 'gegen Spieler',

    // Buttons
    startButton: 'Starten',
    startRandomButton: 'Zufällig starten',
    newGameButton: 'Neues Spiel',
    resumeButton: 'Fortsetzen',
    pauseButton: 'Pause',
    pauseQueuedButton: 'Pause (in Warteschlange...)',
    viewKingsButton: 'Könige zeigen',
    hideKingsButton: 'Könige verbergen',
    viewKingsQueuedButton: 'Könige zeigen (in Warteschlange...)',
    hideKingsQueuedButton: 'Könige verbergen (in Warteschlange...)',
    homeButton: 'Startseite',
    toggleKingVisibility: 'Königssichtbarkeit umschalten',

    // Warning modal
    invalidPlacement: 'Ungültige Platzierung',
    okButton: 'OK',
    warningLightTurn: 'Der helle Spieler ist dran eine Figur zu platzieren!',
    warningDarkTurn: 'Der dunkle Spieler ist dran eine Figur zu platzieren!',
    warningLightRow: 'Helle Figuren müssen in Reihe 0 (deiner Grundreihe) platziert werden!',
    warningDarkRow: 'Dunkle Figuren müssen in Reihe 7 (deiner Grundreihe) platziert werden!',
    warningOccupied: 'Dieses Feld ist bereits besetzt! Wähle ein leeres Feld.',
    warningKingRequired: 'Du musst deinen König ({kingType}) platzieren bevor du deine 5. Figur platzierst!',

    // Piece selection
    dragPieces: 'Ziehe Figuren auf das Brett',
    lightPieces: 'Helle Figuren',
    darkPieces: 'Dunkle Figuren',

    // Mobile
    selectYourKing: 'Wähle deinen König',
    selectPieceToPlace: 'Wähle Figur zum Platzieren',
    moveHistory: 'Zugverlauf',
    historyButton: 'Verlauf',
    backButton: 'Zurück',
    lightTurn: 'Hell ist dran',
    darkTurn: 'Dunkel ist dran',
  },

  // Upgrade Modal
  upgrade: {
    title: 'Auf Premium upgraden',
    accountRequired: 'Du musst ein permanentes Konto erstellen bevor du auf Premium upgraden kannst.',
    createAccountPrompt: 'Erstelle ein Konto um deinen Fortschritt zu speichern und Premium-Funktionen freizuschalten!',
    subtitle: 'Schalte mächtige Funktionen frei um dein Zodiac Chess Erlebnis zu verbessern!',
    features: {
      history: 'Kontoverlauf',
      historyItem1: 'Speichere und rufe alle deine bisherigen Spiele ab',
      historyItem2: 'Spiele deine alten Partien von jedem Punkt ab um Strategie zu evaluieren',
      historyItem3: 'Nutze tiefe Analysen um Brettstellungen und brillante Zugmöglichkeiten zu analysieren',
      analytics: 'Analysen',
      analyticsItem1: 'Erhalte Zugang zu Spielstatistiken',
      analyticsItem2: 'Analysiere Figuren- und Königswahl der Spieler über viele Metriken',
      analyticsItem3: 'Finde heraus welche Metas beliebt sind und was funktioniert!',
      course: 'Kurs',
      courseItem1: 'Erhalte Zugang zu aktuellen Kursen um deine Fähigkeiten zu entwickeln',
      courseItem2: 'Lerne Metas und Konzepte von den Profis',
      courseItem3: 'Erhalte Tipps zu deinem eigenen Spiel um deine Schwächen zu analysieren',
    },
    createAccount: 'Konto erstellen',
    upgradeNow: 'Jetzt upgraden',
    cancel: 'Abbrechen',
  },

  // Premium Modal
  premium: {
    title: 'Premium-Funktion',
    accessDenied: 'Leider hast du kein Premium-Konto, du hast noch keinen Zugang zu diesen Funktionen!',
  },

  // Donation
  donation: {
    title: 'Unterstütze Zodiac Chess',
    supportDevelopment: 'Unterstütze die Entwicklung',
    story1: 'Hallo! Deine Unterstützung hilft mir dieses einzigartige Spiel weiter zu verbessern! Neue Funktionen hinzufügen, Server warten und Zodiac Chess für die Community kostenlos halten.',
    story2: 'Auch eine kleine Spende macht einen großen Unterschied und hält dieses Projekt am Leben. Danke dass du Teil der Zodiac Chess Reise bist :)',
    selectAmount: 'Betrag wählen',
    customAmount: 'Oder eigenen Betrag eingeben:',
    total: 'Gesamt:',
    donateButton: 'Jetzt spenden',
    processing: 'Verarbeitung...',
    disclaimer: 'Spenden unterstützen Entwicklung und Serverkosten. Danke für deine Großzügigkeit!',
    invalidAmount: 'Bitte gib einen gültigen Betrag größer als $0 ein',
    error: 'Es gab einen Fehler bei der Verarbeitung deiner Spende. Bitte versuche es erneut.',
  },

  // Stripe Error Page
  stripe: {
    errorTitle: 'Ups! Etwas ist schiefgelaufen',
    errorMessage: 'Wir hatten ein Problem bei der Verarbeitung deiner Zahlung. Keine Sorge, es wurde nichts abgebucht.',
    whatHappened: 'Was ist passiert?',
    notCompleted: 'Deine Zahlung wurde nicht abgeschlossen. Das könnte daran liegen:',
    reasons: {
      cancelled: 'Zahlung wurde abgebrochen',
      declined: 'Karte wurde abgelehnt',
      connection: 'Verbindungsproblem beim Checkout',
      expired: 'Sitzung abgelaufen',
    },
    whatToDo: 'Was kannst du tun?',
    actions: {
      tryDifferentCard: 'Versuche es mit einer anderen Karte',
      tryDifferentCardDesc: 'Nutze eine andere Zahlungsmethode',
      retryPayment: 'Zahlung wiederholen',
      retryPaymentDesc: 'Manchmal funktioniert ein einfacher Neuversuch',
      checkBank: 'Bei deiner Bank nachfragen',
      checkBankDesc: 'Stelle sicher dass deine Karte genügend Guthaben hat',
    },
    tryAgain: 'Upgrade erneut versuchen',
    returnHome: 'Zur Startseite zurück',
    contactSupport: 'Brauchst du Hilfe? Kontaktiere den Support unter support@zodiac-chess.com',
  },


  // How To Play - Learn the Pieces
  howToPlay: {
    // Section titles
    whatIsZodiac: 'Worum geht es?',
    gameSetup: 'Spielaufbau',
    basicRules: 'Grundregeln',
    backButton: 'BACK',
    homeButton: 'Home',
    fullRules: 'Full Rules',

    // What is Zodiac section
    whatIs: {
      p1: 'Zodiac is a two player abstract strategy game based off of Chess, Poker and DotA.',
      p2: 'It was created in 2014 as a crude version of itself called "Shadow Chess" based off its central principal of a secret king',
      p3: 'Later in 2018 it was redesigned to involve a roster of novel pieces with unique movement patterns and abilities',
      p4: "Zodiac's goal is to celebrate human intuition and novel play. To drive success toward a players ability to bluff and adapt to unfamiliar situations and create a nuanced set of challenges for the ever growing strength of AI",
      p5: "Another goal of Zodiac is to be a game for humans! With a very large search space for play, hidden information, win obfuscation and a changing roster of pieces over time. Zodiac wants to be a player data driven game that keeps creativity mainstay and staves off AI dominance",
      p6: 'We hope you stick around and see where this journey takes us',
    },

    // Setup section
    setup: {
      p1: "Players play a zodiac version of paper, scissors, rock to see who goes first!",
      p2: 'From there, select a piece to be your "King" your opponent won\'t know which one you have chosen.',
      p3: 'Then pick 5 pieces to play with, they all have different abilities, cohesion, strengths and weaknesses!',
      p4: 'Once you are both done the game will begin.',
      p5: 'Simply click on a piece to see where it can move to or click on any unhighlighted square to deselect the piece.',
      p6: 'Good luck!',
    },

    // Basic Rules section
    rules: {
      intro: 'The game of Zodiac is played by two players on a rectangle board made up of 40 squares (5 by 8).',
      toWinTitle: 'To win:',
      toWin1: 'Capture the opponents King',
      toWin2: '"Race" your King across the board',
      toWin3: 'Have your opponents timer expire',
      toWin4: 'Have your opponent surrender',
      drawTitle: 'A draw occurs',
      draw1: 'When a players king is still uncaptured and they cannot make any legal move, or;',
      draw2: 'The same board position is repeated three times',
    },

    // Piece tutorials
    tutorials: {
      bear: {
        desc1: 'Regular movement - The Bear can move one square in any direction',
        desc2: 'The Bear\'s ability "Savage" allows it to capture any piece regardless of defensive abilities',
        desc3: 'The bear is a "large" piece and a "predator" piece meaning many of the other Zodiacs cannot capture it!',
      },
      crane: {
        desc1: 'The Crane can move 1 or 2 in any straight line for its regular movement',
        desc2: "The Crane cannot capture any 'large' or 'predator' pieces",
      },
      frog: {
        desc1: 'The frog can jump 2 on diagonals for its regular movement, even over other pieces!',
        desc2: "If the frog's regular movement is blocked by a wall or a piece it cannot capture, its regular movement is shortened to 1 square diagonally",
        desc3: "If the frog has yet to make a move in the game, it is on its 'lily pad' and can move to any of the first 3 ranks as a defensive movement",
        desc4: 'If a piece captures a frog, it becomes poisoned and cannot make any move for its next available turn',
        desc5: "The frogs special movement is 'wall climb' if a frog is beside the edge of the board, it can also move one up or down",
      },
      fungi: {
        desc1: 'The Fungi can move one in any direction for its regular movement',
        desc2: "The fungi's ability 'meadow' prevents a tree from moving if it is within one square of the fungi and does not allow a tree to move within one square of the enemy fungi",
        desc3: "When captured the fungi applies a 'zombie' effect to any animal piece that captured it",
        desc4: 'While zombified, the fungi controls the piece for the following turn and acts as the piece, meaning if the fungi was your king, you can still win by race victory or capturing the enemy king within that round',
      },
      goat: {
        desc1: 'The goat can move one in any direction for its regular movement',
        desc2: "The goats ability 'traverse' allows it to hop across linked pieces and then move, it cannot capture any piece on a traverse",
        desc3: "The goat cannot capture any 'predators'",
        desc4: "The goat can use a special ability called 'faint' to make itself appear dead",
        desc5: "While fainted, the goat is unable to be captured by most pieces but cannot move if another piece is 'standing' on it (on the same square)",
      },
      monkey: {
        desc1: 'The monkey can move one in any direction for its regular movement',
        desc2: "The monkey can 'leap' over friendly and enemy pieces like a checkers piece if the formation allows it",
        desc3: 'If the monkey does leap over an enemy piece it must roll a dice to not be captured! One danger point per enemy piece it leaps in a single line',
        desc4: 'The monkey CAN capture a bear if it decides to gamble to attack it, on a 1-4 roll on a six sided dice, the Monkey is captured, on a 5 or 6, the Monkey captures the bear',
        desc5: "The monkey has two abilities - 'swing' and 'consume' on a swing (a leap ending over a tree) the monkey gains an extra movement, on a consume of any fungi, the monkey also gains one extra movement before its turns end",
      },
      octopus: {
        desc1: 'The octopus can move one in any direction for its regular movement',
        desc2: 'The octopus may only capture on orthagonal squares',
        desc3: "The octopus can use its ability 'entangle' on any animal piece on diagonal squares",
        desc4: 'The octopus may make any move AND entangle in one turn',
        desc5: "The octopus has an ability called 'ink' with this ability it can move to any orthagonal square and place 'shadows' on the other 3 orthagonal squares if they are not occupied or off of the board. To the opponent for the round following the 'ink' ability the shadows and real octopus are indistinguishable",
      },
      penguin: {
        desc1: "The penguin has an ability called 'rotate' it is the only piece that has a set direction and may use the 'rotate' move to redirect its direction for its turn",
        desc2: "For the penguins regular movement 'slide' it must move to the furthest point in the direction it is facing and once there, it may use a rotate before its turns end to redirect its direction",
        desc3: "The penguin cannot capture any 'large' or 'predator' pieces. It can capture any other piece within one square of itself and use a rotate ability after the capture",
      },
      rhino: {
        desc1: "The rhino can move 'back left', 'back right' or two forward as part of its regular movement",
        desc2: "The rhino has an ability called 'trample' where captures ALL pieces in the path of its movement",
        desc3: 'Once per game a rhino may perform a charge of 3 squares ahead if any animal is present in any of the 3 squares directly infront of the rhino',
        desc4: 'The rhino has a special ability called "rhino defence" where the rhino cannot be captured from \'the front\'',
        desc5: "The rhino has an ability called 'lane' where if it has not moved and the friendly piece directly to its left or right has not moved, it can switch places with that piece for its turn",
      },
      snake: {
        desc1: 'The snake can move 2 squares only in orthagonal directions, including through other pieces for its regular movement',
        desc2: 'If its regular movement is blocked by a wall or a piece it cannot capture, its regular movement becomes 1',
        desc3: 'The snake has an ability called "strike" where if an animal is exactly 3 squares ahead of it and there are no pieces between, it can \'strike\' forward and capture that animal',
        desc4: 'The snake has an ability called "shed" where once per game if the snake is captured, it will return to the first rank of the board, in the same column, as if it had a second life. If the first rank is not a valid square for the snake to move to, it is permanently captured',
      },
      tree: {
        desc1: 'The tree may move one forward or unlimitedly side to side if not blocked by any other piece',
        desc2: "The tree has a special ability called 'house' where any piece that can 'climb' tree's may sit on top of the tree piece. If an enemy piece attacks a tree with a housed piece, the housed piece is captured and the tree houses the enemy piece",
        desc3: 'When a piece is housed in the tree, if an enemy piece cannot climb the tree, both the tree and the housed piece are protected from capture',
      },
      wolf: {
        desc1: 'The wolf moves in an L shape like a knight in chess for its regular movement',
        desc2: "If the wolf is the last piece on the board* it's ability 'lone wolf' is activated and it moves in a long L instead as pictured above. *The wolf will enter lone if on a team with a fainted goat or infecting virus",
      },
      virus: {
        desc1: "The virus may move 2 squares in any straight line for its regular movement, it does not capture but uses its ability 'infect' to cause the piece to be infected rather than captured",
        desc2: "The virus can only move to any animal piece, if blocked by a wall, the virus's regular movement is only 1 square",
        desc3: "When an animal piece is 'infected' if the virus leaves the infected piece in to another piece, the piece it left is captured and the new piece is 'infected'",
        desc4: "The virus has an ability called 'infectious' which allows the virus to complete as many valid moves in one move as it likes, capturing multiple animals in one turn",
        desc5: "While not 'infecting' the virus can be captured like any other piece, if an animal captures an infected piece, it becomes infected",
      },
    },
  },
};
